export default "__VITE_ASSET__CoyiYRsJ__"